var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page"},[_c('vue-headful',{attrs:{"title":`404 Not Found • ${_vm.appName}`}}),_c('div',{staticClass:"centered"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.message))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }